
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"180","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".06","stroke":"#000C1F","d":"M.5-20.625v191.671"}}),_c('path',{attrs:{"opacity":".21","stroke":"#000C1F","d":"M103.773-92.954v264"}}),_c('path',{attrs:{"opacity":".12","stroke":"#000C1F","d":"M26.318-20.625v191.671"}}),_c('path',{attrs:{"opacity":".24","stroke":"#000C1F","d":"M129.591-92.954v264"}}),_c('path',{attrs:{"opacity":".15","stroke":"#000C1F","d":"M52.136-20.625v191.671"}}),_c('path',{attrs:{"opacity":".24","stroke":"#000C1F","d":"M155.409-92.954v264"}}),_c('path',{attrs:{"opacity":".18","stroke":"#000C1F","d":"M77.955-20.625v191.671"}})])
          )
        }
      }
    